import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import userManager from "../../userManager";

class RegisterNewUser extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
        lastName : '',
        firstName : '',
        customerId : '',
        email: '',
        message: '',
        cdbUser: false,
        cdbAdmin: false,
        cfAdmin: false,
        itAdmin: false
    };
    
    this.registerNewUser = this.registerNewUser.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event){
    if (event.target.name === 'first_name')
      this.setState({firstName: event.target.value});
    if (event.target.name === 'last_name')
      this.setState({lastName: event.target.value});
    if (event.target.name === 'email')
      this.setState({email: event.target.value});
    if (event.target.name === 'cust_id')
          this.setState({ customerId: event.target.value });
      if (event.target.name === 'userCheckbox')
          this.setState({ cdbUser: event.target.checked });
      if (event.target.name === 'adminCheckbox')
          this.setState({ cdbAdmin: event.target.checked });
      if (event.target.name === 'cfAdminCheckbox')
          this.setState({ cfAdmin: event.target.checked } );
      if (event.target.name === 'itAdminCheckbox')
          this.setState({ itAdmin: event.target.checked });
  }
  
  registerNewUser(){
    let body = {
      lastName : this.state.lastName,
      firstName : this.state.firstName,
      customerId : this.state.customerId,
        email: this.state.email,
        cdbUser: this.state.cdbUser,
        cdbAdmin: this.state.cdbAdmin,
        cfAdmin: this.state.cfAdmin,
        itAdmin: this.state.itAdmin
    };
    
    if (body.customerId === ''){
      this.setState({message: 'Customer ID cannot be empty'});
    } else if (body.lastName === ''){
      this.setState({message: 'Last name cannot be empty'});
    } else if (body.firstName === ''){
      this.setState({message: 'First name cannot be empty'});
    } else if (body.email === ''){
      this.setState({message: 'E-mail cannot be empty'});
    } else {
      apiPutPost(this.props, body).then((response) => {
        this.setState({message: response});
      });
    }
  }
  
    render() {
        
    if (this.props.user.profile.it_admin === 'true'){
      return (
        <div className="centered-container border" >
          <div className="form-warning-message">
            {this.state.message}
          </div>
          <form className="register-form" style={{width: "90%"}}>
            <input className="form-input-text" type="text" name="email" value={this.state.email} onChange={this.handleChange}placeholder="Email" />
            <input className="form-input-text" type="text" name="first_name" value={this.state.firstName} onChange={this.handleChange} placeholder="First Name" />
            <input className="form-input-text" type="text" name="last_name" value={this.state.lastName} onChange={this.handleChange} placeholder="Last Name" />
            <input className="form-input-text" type="text" name="cust_id" value={this.state.customerId} onChange={this.handleChange} placeholder="Customer ID" />
            <div className="checkbox form-input-checkbox">
                <input type="checkbox" name="userCheckbox" onChange={this.handleChange} />
                <label className="register-checkbox-label" htmlFor="checkbox">Is Customer Dashboard User</label>
                <input type="checkbox" name="adminCheckbox" onChange={this.handleChange} />
                <label className="register-checkbox-label" htmlFor="checkbox">Is Customer Dashboard Admin</label>
                <input type="checkbox" name="cfAdminCheckbox" onChange={this.handleChange} />
                <label className="register-checkbox-label" htmlFor="checkbox">Is Commercial Fire Admin</label>
                <input type="checkbox" name="itAdminCheckbox" onChange={this.handleChange} />
                <label className="register-checkbox-label" htmlFor="checkbox">Is IT Admin</label>
            </div>
            <button className="btn-secondary btn-form" type="button" name="button" onClick={this.registerNewUser}>Register</button>
          </form>
        </div>
        
      );
    }else{
      return null;
    }
  }

}

async function apiPutPost(props, body){
  const url = `api/cfadmin/registeruser/`;
  const path = window.location.pathname;
  let message;
  
  await fetch(url, {
    method: 'POST',
    headers: new Headers({
      'Authorization': 'Bearer ' + props.user.access_token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }),
    body: JSON.stringify(body)
  }).then((response) => {
      console.log("response is ")
      console.log(response)
      console.log(body)
    if (response.status === 200) {
      message = "User has been created and sent a confirmation e-mail.";
    } else if (response.status === 404) {
        message = "Invalid customer ID used.";
    } else if (response.status === 403) {
        message = "Email did not send. Please contact a developer for assistance.";
    } else if ( response.status === 400 ){
      message = "User already exists."
    } else {
      message = "Server was unable to create the user at this time. Tell IT.";
    }
  }).catch((error) =>{
    message = "Unable to access the server at this time.";
    throw error;
  });

  return message;
}

const mapStateToProps = function(state) {
  return {
    user: state.oidc.user
  }
};

//export default NavMenu;
export default withRouter(connect(mapStateToProps)(RegisterNewUser));